import {mixin} from "@/helpers/helper";

export default {
    namespaced: true,
    state: {
        bread_active: null,
        bread_list: null,
        regionList: null,
        cityList: null,
        regionName: null,
        regionListData: null,
        cityName: null,
        cityData: null,
        cityId: null,
        auctionListByCityData: null,
        myCityIdSelected: null,
        formData: {},
        myError: null,
        idToDelete: null,
        idZoneToDelete: null,

        showMessageImportCompleted: false,
        categoriesList: [],
        tribunalsList: [],
        typologiesList: [],
        buildingList: [],
        showLoading: false,
        showImportBtn: false,
        showMoreBtn: false,
        streetPriceSaved: false,
        allSearched: false,
        auctionListColored: null,

    },
    getters: {},
    mutations: {
        SET_DATA(state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        lastAuction(state) {
            axios.get('/api/v2/auction/lastAuction')
                .then(response => {
                    state.dispatch('cityListUsed', {
                        region: response.data.region
                    });
                    state.dispatch('auctionListByCity', {
                        cityId: response.data.cityId,
                        city: response.data.city,
                    })

                    state.dispatch('completeRegionList');
                })
        },
        regionListUsed(state) {
            axios.get('/api/v2/auction/regionListUsed')
                .then(response => {
                    state.commit('SET_DATA', {name: 'regionList', data: response.data});
                })
        },

        cityListUsed(state, payload) {
            state.commit('SET_DATA', {name: 'regionName', data: payload.region});
            axios.post('/api/v2/auction/cityListUsed', payload)
                .then(response => {
                    state.commit('SET_DATA', {name: 'cityList', data: response.data});
                })
        },

        auctionListByCity(state, payload) {
            state.commit('SET_DATA', {name: 'cityName', data: payload.city});
            state.commit('SET_DATA', {name: 'cityId', data: payload.cityId});
            axios.get('/api/v2/auction/auctionListByCity/' + payload.cityId + '/' + payload.color)
                .then(response => {
                    state.commit('SET_DATA', {name: 'auctionListByCityData', data: response.data.data});
                    state.commit('SET_DATA', {name: 'myCityIdSelected', data:  payload.cityId});
                });
        },

        changeColor(state, payload) {
            axios.post('/api/v2/auction/changeColor', {
                auctionId: payload.data.id,
                color: payload.color
            })
                .then(response => {
                    state.dispatch('auctionListByCity', {
                        color: 0,
                        city: state.state.cityName,
                        cityId: state.state.cityId,
                    })
                })
        },

        completeRegionList(state) {
            axios.get('/api/v2/auction/regionList')
                .then(response => {
                    state.commit('SET_DATA', {name: 'regionListData', data: response.data});
                })
        },

        cityListByRegion(state, payload) {
            axios.get('/api/v2/auction/cityList/' + payload.region)
                .then(response => {
                    state.commit('SET_DATA', {name: 'cityData', data: response.data});
                })
        },

        sendData(state) {
            let formData = state.state.formData;

            axios.post('/api/v2/auction/save', {
                city_id: formData.city_id,
                regione: formData.regione,
                indirizzo: formData.indirizzo,
                rge: formData.rge,
                valore_ctu: mixin.methods.REMOVE_DOT(formData.valore_ctu),
                mq: mixin.methods.TRANSFORM_NULL_TO_ZERO(formData.mq),
                n_incanto: formData.n_incanto,
                base_asta: mixin.methods.REMOVE_DOT(formData.base_asta),
                offerta_minima: mixin.methods.REMOVE_DOT(formData.offerta_minima),
                rialzo_minimo: mixin.methods.REMOVE_DOT(formData.rialzo_minimo),
                rendita_catastale: mixin.methods.REMOVE_DOT(formData.rendita_catastale),
                data_asta: formData.data_asta,
                reg_urbanistica: formData.reg_urbanistica,
                n_creditori: mixin.methods.TRANSFORM_NULL_TO_ZERO(formData.n_creditori),
                stato_occupazionale: formData.stato_occupazionale,
                valore_immobiliare_it: mixin.methods.REMOVE_DOT(formData.valore_immobiliare_it),
                valore_borsino_immobiliare: mixin.methods.REMOVE_DOT(formData.valore_borsino_immobiliare),
                street_price: mixin.methods.REMOVE_DOT(formData.street_price),
                street_price_asta: mixin.methods.REMOVE_DOT(formData.street_price_asta),
                agenzia_1: mixin.methods.REMOVE_DOT(formData.agenzia_1),
                agenzia_2: mixin.methods.REMOVE_DOT(formData.agenzia_2),
                agenzia_3: mixin.methods.REMOVE_DOT(formData.agenzia_3),
                riferimenti_custode: formData.riferimenti_custode,
                note: formData.note,
                stralciabile: formData.stralciabile,
                color: formData.color,
                id: formData.id
            })
                .then(() => {
                    state.dispatch('auctionListByCity', {cityId: formData.city_id});
                });
        },

        createOperation(state, payload) {
            axios.get('/api/v2/auction/createOperation/' + payload.id)
                .then(response => {
                    window.location.href = '/auction_operation/detail/' + payload.id + '/' + response.data.idOperation;
                })
        },

        deleteAuction(state) {
            axios.get('/api/v2/auction/deleteSingleAuction/' + state.state.idToDelete)
                .then(response => {
                    state.dispatch('auctionListByCity',
                        {
                            city: state.state.cityName,
                            cityId: state.state.cityId
                        })
                })
        },

        deleteZoneAuction(state) {
            axios.get('/api/v2/auction/deleteZoneAuction/' + state.state.idZoneToDelete)
                .then(response => {
                    window.location.reload()
                    // state.dispatch('auctionListByCity',
                    //     {
                    //         city: state.state.cityName,
                    //         cityId: state.state.cityId
                    //     })
                })
        },

        initAuctionMapping(state) {
            axios.get('/api/v2/auction/initMapping')
                .then(response => {
                    state.commit('SET_DATA', {data: {}, name: 'formData'});
                    state.commit('SET_DATA', {data: response.data.categories, name: 'categoriesList'});
                    state.commit('SET_DATA', {data: response.data.tribunals, name: 'tribunalsList'});
                    state.commit('SET_DATA', {data: response.data.typologies, name: 'typologies'});
                    state.commit('SET_DATA', {data: response.data.typologies, name: 'typologiesList'});
                })
        },

        setTypologies(state, payload) {
            let newTypologies = state.state.typologies.filter(typology => {
                if (!payload) {
                    return typology;
                }
                return typology.id_categoria === payload.categoryId;
            });

            state.commit('SET_DATA', {data: newTypologies, name: 'typologiesList'});
        },

        sendSearchFilters(state, payload) {
            state.state.formData.minimum_base = payload.range[0];
            state.state.formData.maximum_base = payload.range[1];
            state.state.formData.radius = payload.radiusValue;
            state.state.formData.location = payload.location;
            state.state.formData.index = payload.index;
            if (state.state.formData.index > 1) {

                axios.post('/api/v2/auction/searchBuilding', state.state.formData)
                    .then(response => {
                        state.commit('SET_DATA', {
                            data: state.state.buildingList.data.concat(response.data),
                            name: 'buildingList.data'
                        });
                        state.commit('SET_DATA', {data: false, name: 'showLoading'});
                        state.commit('SET_DATA', {data: true, name: 'showImportBtn'});
                        state.commit('SET_DATA', response.data.length > 0 ? {
                            data: true,
                            name: 'showImportBtn'
                        } : {data: false, name: 'showMoreBtn'});
                        state.commit('SET_DATA', response.data.length > 0 ? {
                            data: false,
                            name: 'allSearched'
                        } : {data: true, name: 'allSearched'});
                    });
            } else {
                axios.post('/api/v2/auction/searchBuilding', state.state.formData)
                    .then(response => {
                        state.commit('SET_DATA', {data: response, name: 'buildingList'});
                        state.commit('SET_DATA', {data: false, name: 'showLoading'});
                        state.commit('SET_DATA', {data: true, name: 'showImportBtn'});
                        state.commit('SET_DATA', {data: true, name: 'showMoreBtn'});
                        state.commit('SET_DATA', {data: false, name: 'allSearched'});
                    });
            }

        },

        importData(state, payload) {
            axios.post('/api/v2/auctionimport/importData', {
                buildingData: state.state.buildingList,
                checkedBuildings: payload.checkedBuildings,
            })
                .then(() => {
                    state.commit('SET_DATA', {data: true, name: 'showMessageImportCompleted'});
                    state.commit('SET_DATA', {data: [], name: 'buildingList'}); // reset data after import
                })
        },

        saveStreetPriceInAuction(state, payload) {
            state.commit('SET_DATA', {name: 'streetPriceSaved', data: false});
            axios.post('/api/v2/auction/saveStreetPriceInAuction', {
                auctionID: payload.auctionID,
                streetPrice: payload.streetPrice,
            })
                .then(() => {
                    state.commit('SET_DATA', {name: 'streetPriceSaved', data: true});
                })

        },

        auctionListByColor(state) {
            axios.get('/api/v2/auction/4') // 4 = green
                .then(response => {
                    state.commit('SET_DATA', {name: 'auctionListColored', data: response.data.data});
                })
        }

    }
}
